import moment from 'moment'

import formReducer from '../formsReducer'

const initialState = {
  start_date: moment().subtract(3, 'months'),
  end_date: moment(),
  unit: 'month',
}

const formName = 'reports/date'

export default formReducer(formName, initialState)
